

<div class="modal-signup modal-content" *ngIf="ShowList">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

    <div class="card-header wh-header border-bottom">
      <label class="margin-bottom-0px nav-link-hand"><i class="fas fa-pencil-alt nav-link-hand"></i> Specimen</label> 
      <button type="button" class="close" data-dismiss="modal"
              (click)="activeModal.dismiss('Cross click')"
              aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form class="form" (ngSubmit)="onSubmit()">
      <div class="modal-body overflow-x padding-top-0px">

        <section id="form-action-layouts">


          <div class="row justify-content-md-center">
            <div class="col-md-12 padding-left-0px">
              <div class="card margin-left-0px margin-right-0px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">

                  <div class="px-6">



                    <div class="form-body">

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-0px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Is Specimen Available </label>
                            </div>
                            <div class="col-md-4 padding-left-0px padding-top-5px">

                              <input type="checkbox" class="checkbox1" [(ngModel)]="model.IsSpecimenAvailable" name="isSpecimenAvailable" />


                            </div>

                          </div>

                        </div>
                      </div>



                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Specimen Source </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px" [(ngModel)]="model.SpecimenSource" name="specimenSource">
                                <option value="Serum"> Serum </option>
                                <option value="Whole Blood"> Whole Blood </option>
                                <option value="Plasma"> Plasma </option>
                                <option value="Urine"> Urine </option>
                                <option value="CSF"> CSF </option>
                                <option value="Swab"> Swab </option>
                                <option value="Sputum"> Sputum </option>
                              </select>


                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Quantity </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="number" class="form-control padding-left-0px" [(ngModel)]="model.Quantity" name="quantity">

                            </div>

                          </div>

                        </div>
                      </div>



                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> UOM </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px" [(ngModel)]="model.UOM" name="uom">
                                <option value="ML"> ML </option>
                                <option value="UL"> UL </option>
                                <option value="Drop"> Drop </option>
                                <option value="Specimen"> Specimen </option>
                                <option value="Unit"> Unit </option>
                              </select>


                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Organism </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px" [(ngModel)]="model.Organism" name="organism">
                                <option value=""> None </option>
                                <option value="Bacteria"> Bacteria </option>
                                <option value="Virus"> Virus </option>
                                <option value="Fungus"> Fungus </option>
                                <option value="Parasite"> Parasite </option>
                              </select>

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-0px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Has Test Method </label>
                            </div>
                            <div class="col-md-4 padding-left-0px padding-top-5px">

                              <input type="checkbox" class="checkbox1" [(ngModel)]="model.HasTestMethod" name="hasTestMethod" />


                            </div>

                          </div>

                        </div>
                      </div>

                      

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Test Method (Kit) </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px" [(ngModel)]="model.TestMethod" name="testMethod">
                                <option value=""> Default Method </option>
                                <option value="ELISA"> ELISA </option>
                                <option value="PCR"> PCR </option>
                                <option value="Microscopy"> Microscopy </option>
                                <option value="Culture"> Culture </option>
                                <option value="Automated"> Automated </option>
                              </select>


                            </div>

                          </div>

                        </div>
                      </div>



                    </div>










                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="ModalClose()">Back</button>
        <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>

      </div>

    </form>
  </div>
</div>




